import axios from "axios";
import Swal from "sweetalert2";

let aPIRootUrl = "";
const env = process.env.NODE_ENV;

switch (env) {
  case "local":
    aPIRootUrl = process.env.REACT_APP_API_BASE_LOCAL_URL;
    break;
  case "development":
    aPIRootUrl = process.env.REACT_APP_API_BASE_DEV_URL;
    break;
  case "production":
    aPIRootUrl = process.env.REACT_APP_API_BASE_PROD_URL;
    break;
  default:
    aPIRootUrl = "";
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

let isHandlingUnauthorized = false;

const safelyParseStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "{}");
  } catch (error) {
    return {};
  }
};

const getAuthToken = () => {
  const userDataRegister = safelyParseStorage("userRegData");
  const userDataLogin = safelyParseStorage("userLoginData");

  return userDataRegister?.token || userDataLogin?.token || "";
};

const handleUnauthorizedLogout = () => {
  if (isHandlingUnauthorized) return;

  isHandlingUnauthorized = true;
  localStorage.clear();

  Swal.fire({
    title: "Session expired",
    text: "Your session has expired. Logging you out",
    icon: "warning",
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    timer: 1800,
  }).finally(() => {
    window.location.replace("/");
  });
};

api.interceptors.request.use(function (config) {
  //   const state = typeof store !== 'undefined' ? store.getState() : { auth: {} };
  //   const user = state.auth
  //   const token =  Object.keys(user.registerData).length === 0? user.loginData.token : Object.keys(user.loginData).length === 0 ? user.registerData.token : ""
  const token = getAuthToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && getAuthToken()) {
      handleUnauthorizedLogout();
    }

    return Promise.reject(error);
  }
);

export default api;
